enum RoutePath {
  root = "/",
  welcomePage = "/welcome",
  loginPage = "/login",
  passwordPage = "/password",
  conferencePage = "/conference",
  unregistred = "*",
}

export default RoutePath;
